import ApiService from '@services/api.service'

export default {
    resource: '',

    list(params = null) {
        return ApiService.get(`/${this.resource}`, params)
    },

    selectBy(params = null) {
        return ApiService.get(`${params}`)
    },

    show(model) {
        return ApiService.get(`/${this.resource}/` + model.id)
    },

    store(model) {
        return ApiService.post(`/${this.resource}`, model)
    },

    update(model) {
        return ApiService.put(`/${this.resource}/` + model.id, model)
    },

    delete(model) {
        return ApiService.delete(`/${this.resource}/` + model.id)
    }
}
